import React from 'react';
import config from '../config';
import { is, jsBridge } from 'cl-util';

const loadcomps = loadComponent => (
  class Loadcomps extends React.Component {

    constructor(props) {
      super(props);
      this.state = {
        Component: null,
      };
    }

    componentDidMount() {
      if (this.hasLoadedComponent()) return;

      loadComponent()
        .then(module => module.default)
        .then((Component) => {
          this.setState({
            Component
          }, () => {
            // 设置页面标题
            const page = config.pages.find(page => page.hash === this.props.location.pathname);
            let pageTitle = '404';
            page && (pageTitle = page.title);
            console.log(pageTitle)
            if (is.chelun) {
              // 端内需要通过jsBridge api修改标题
              jsBridge("ui", "setTitle", { title: pageTitle });
            }
            document.title = pageTitle;
          });
        })
        .catch((err) => {
          console.error('Cannot load component in <Loadcomps />');
          throw err;
        });
    }

    hasLoadedComponent() {
      return this.state.Component !== null;
    }

    render() {
      const {
        Component
      } = this.state;
      return Component && <Component {...this.props} />;
    }

  }
);

export default loadcomps;